export const MUTATION_GROUP = 'colorFields' as const;
